import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import EmailCustomers from './EmailCustomers.vue'
import EmailLog from './EmailLog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailTab',
  setup(__props) {

// Email tab of the Messages page: by customer by default; the Every message filter
// toggle swaps in the per-message log, and switching it off comes back here.
const allMessages = ref(false)

return { __sfc: true,allMessages, EmailCustomers, EmailLog }
}

})